import React from 'react';
import Webcam from 'react-webcam';
import PropTypes from 'prop-types';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCamera, faTimes} from '@fortawesome/free-solid-svg-icons';
import styles from './index.module.scss';

const WebcamCapture = ({onCapture, onClose, minWidth = 2000}) => {
  const webcamRef = React.useRef(null);
  const multiplier =
    window.innerWidth < minWidth ? minWidth / window.innerWidth : 1;

  const width = Math.floor(window.innerWidth * multiplier);
  const height = Math.floor(window.innerHeight * multiplier);

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot({
      width,
      height,
    });
    if (imageSrc) {
      onCapture(imageSrc);
    }
  }, [webcamRef]);
  return (
    <div className={styles.webcam}>
      <div className={styles.video}>
        <Webcam
          audio={false}
          height={height}
          ref={webcamRef}
          screenshotFormat='image/jpeg'
          width={width}
          videoConstraints={{
            aspectRatio: width / height,
            width,
            height,
            facingMode: 'environment',
          }}
        />
      </div>
      <button onClick={onClose} type='button' className={styles.close}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <button onClick={capture} type='button' className={styles.button}>
        <FontAwesomeIcon icon={faCamera} />
      </button>
    </div>
  );
};

WebcamCapture.propTypes = {
  onCapture: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  minWidth: PropTypes.number,
};
export default WebcamCapture;
